import {
	CreateCancellationCommand,
	UpdateCancellationCommand,
} from '@acorn-portal/shared/src/services/cancellation-api';

type CancellationCommand = CreateCancellationCommand | UpdateCancellationCommand;

export type CommandDate = CancellationCommand['cancellationDate'];
export type CommandReason = CancellationCommand['cancellationReason'];

type OmitField = 'date' | 'reason';

const hasChanged = <T>(next: T, prev: T) => next !== prev;

/**
 * Checks if the cancellation command has changed, with the option to omit fields for comparison.
 * @param commandDate The new cancellation date.
 * @param previousCommandDate The previous cancellation date.
 * @param commandReason The new cancellation reason.
 * @param previousCommandReason The previous cancellation reason.
 * @param omit Fields to omit from the change check
 * @returns True if the command has changed, false otherwise.
 */
export const checkCancellationCommandChange = (
	commandDate: CommandDate,
	previousCommandDate: CommandDate,
	commandReason: CommandReason,
	previousCommandReason: CommandReason,
	omit: OmitField[] = [],
): boolean => {
	if (omit.length === 2) return false; // both omitted

	const omitSet = new Set<OmitField>(omit);
	const dateChanged = !omitSet.has('date') && hasChanged(commandDate, previousCommandDate);
	const reasonChanged = !omitSet.has('reason') && hasChanged(commandReason, previousCommandReason);

	return dateChanged || reasonChanged;
};
